import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './DropdownMenu.scss';

const DropdownMenu = ({ isOpen, onClose, options, position = 'bottom-right', className = '' }) => {
   const menuRef = useRef(null);

   useEffect(() => {
      const handleClickOutside = event => {
         if (menuRef.current && !menuRef.current.contains(event.target)) {
            onClose();
         }
      };

      if (isOpen) {
         document.addEventListener('mousedown', handleClickOutside);
      }
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, [isOpen, onClose]);

   if (!isOpen) return null;

   return (
      <div className={`callDropdownMenu ${position} ${className}`} ref={menuRef}>
         <ul className="callDropdownList">
            {options.map(opt => (
               <li key={opt.id || opt.label}>
                  <button
                     type="button"
                     className={`callDropdownItem ct-flex ct-aiCenter ct-gap12 ct-cursor ct-wFull ${opt.danger ? 'danger' : ''}`}
                     onClick={e => {
                        e.stopPropagation();
                        opt.onClick();
                        onClose();
                     }}
                  >
                     {opt.icon && <i className="ct-icon xs">{opt.icon}</i>}
                     <span className="callDropdownLabel">{opt.label}</span>
                  </button>
               </li>
            ))}
         </ul>
      </div>
   );
};

DropdownMenu.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   options: PropTypes.arrayOf(
      PropTypes.shape({
         id: PropTypes.string,
         label: PropTypes.string.isRequired,
         onClick: PropTypes.func.isRequired,
         icon: PropTypes.node,
         danger: PropTypes.bool,
      }),
   ).isRequired,
   position: PropTypes.string,
   className: PropTypes.string,
};

export default DropdownMenu;
